import { render, staticRenderFns } from "./Helpdesk.vue?vue&type=template&id=537a3798&scoped=true"
import script from "./Helpdesk.vue?vue&type=script&lang=js"
export * from "./Helpdesk.vue?vue&type=script&lang=js"
import style0 from "./Helpdesk.vue?vue&type=style&index=0&id=537a3798&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "537a3798",
  null
  
)

export default component.exports